module.exports = {"139002100":"辛集镇","139002101":"旧城镇","139002102":"张古庄镇","139002103":"位伯镇","139002104":"新垒头镇","139002105":"新城镇","139002106":"南智邱镇","139002107":"王口镇","139002200":"天宫营乡","139002201":"前营乡","139002202":"马庄乡","139002203":"和睦井乡","139002204":"田家庄乡","139002205":"中里厢乡","139002206":"小辛庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/139002.json
// module id = 345
// module chunks = 0